import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';
import UIRegions from 'shared/constants/UIRegions';
import RemoteTeleprompterStore from 'flux/stores/cuesheet.fullscreen/RemoteTeleprompterStore';
import ModalStore from 'flux/stores/ModalStore';
import Clock from 'shared/components/event/clock.jsx';
import CueClock from 'main/components/show/cuesheet/cueClock.jsx';

export default React.createClass({
  displayName: 'TeleprompterHeaderClocks',

  mixins: [
    Reflux.connect(RemoteTeleprompterStore, 'remoteTeleprompter'),
    Reflux.connect(ModalStore, 'modal'),
  ],
  render() {
    const { floating } = this.props;
    const { modal, remoteTeleprompter } = this.state;
    const { displayClocks } = remoteTeleprompter;

    if (!displayClocks) return null;
    //Don't show the floating clocks until the onboarding modal is dismissed
    if (
      floating &&
      (!modal.has(UIRegions.RemotePrompterOnboardingModal) ||
        modal.get(UIRegions.RemotePrompterOnboardingModal))
    ) {
      return null;
    }

    return (
      <div
        className={classNames('teleprompter-clocks-wrapper', {
          'floating-teleprompter-clocks': floating,
        })}
      >
        <div className="cue-clock-wrapper">
          <CueClock />
        </div>
        <div className="event-clock-wrapper">
          <Clock />
        </div>
      </div>
    );
  },
});
